import { render, staticRenderFns } from "./JcdcDualSelect.vue?vue&type=template&id=15670312&scoped=true"
import script from "./JcdcDualSelect.vue?vue&type=script&lang=ts"
export * from "./JcdcDualSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15670312",
  null
  
)

export default component.exports